import React, { Fragment, useState, useEffect } from 'react';
import { Row, Card, Col, Input, FormGroup, Label } from 'reactstrap';
import { H6, P, LI, UL, Btn } from '../../../AbstractElements';
import ManagePromoCode from '../../../api/ManagePromoCode';
import { toast } from 'react-toastify';

const PromoCodeDataLoop = ({ promoCodes, reloadPromoCodes }) => {
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});
  const [saving, setSaving] = useState(false);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR');
  };

  // Initialize editData with the first promo code when promoCodes loads
  useEffect(() => {
    if (promoCodes && promoCodes.length > 0) {
      setEditData({ ...promoCodes[0] });
    }
  }, [promoCodes]);

  const handleEdit = (promo) => {
    setEditingId(promo.id);
    setEditData({ ...promo });
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditData({});
  };

  const handleSave = (promo) => {
    setSaving(true);
    
    // Check if this is an add or update operation
    const isUpdate = promo && promo.id;
    
    const dataToSave = {
      code1: editData.code1 !== undefined ? editData.code1 : '',
      code2: editData.code2 !== undefined ? editData.code2 : '',
      code3: editData.code3 !== undefined ? editData.code3 : '',
      cote_code1: editData.cote_code1 !== undefined ? editData.cote_code1 : '',
      cote_code2: editData.cote_code2 !== undefined ? editData.cote_code2 : '',
      cote_code3: editData.cote_code3 !== undefined ? editData.cote_code3 : '',
      play_now_link: editData.play_now_link !== undefined ? editData.play_now_link : ''
    };

    // Add id for update operation
    if (isUpdate) {
      dataToSave.id = promo.id;
    }

    const apiCall = isUpdate 
      ? ManagePromoCode.updatePromoCode(dataToSave)
      : ManagePromoCode.addPromoCode(dataToSave);

    apiCall
      .then(response => {
        console.log('Promo code saved:', response.data);
        toast.success(isUpdate ? 'Code promo mis à jour avec succès!' : 'Code promo ajouté avec succès!');
        setEditingId(null);
        setEditData({});
        setSaving(false);
        // Reload the promo codes list
        if (reloadPromoCodes) {
          reloadPromoCodes();
        }
      })
      .catch(error => {
        console.error('Error saving promo code:', error);
        toast.error('Erreur lors de l\'enregistrement du code promo. Réessayer plus tard.');
        setSaving(false);
      });
  };

  const handleInputChange = (field, value) => {
    setEditData({ ...editData, [field]: value });
  };

  return (
    <Fragment>
      <Row>
        {promoCodes.length > 0 ? (
          promoCodes.map((promo) => (
            <Col xl='3' className='xl-50 box-col-4' md='4' key={promo.id}>
              <Card className='card-with-border bookmark-card o-hidden'>
                <div className='details-website'>
                  <div className='desciption-data'>
                    <div className='title-bookmark'>
                      
                      <div className=' mb-3'>
                          <H6 attrH6={{ className: 'mb-2' }}>Code Promo #{promo.code1}</H6>
                          <FormGroup className='mb-2'>
                              <Label>Code 1:</Label>
                              <Input
                                  type='text'
                                  value={editData.code1 || ''}
                                  onChange={(e) => handleInputChange('code1', e.target.value)}
                                  className='form-control-sm'
                              />
                              <small className='text-muted'>Ajouté: {formatDate(promo.code1_added)}</small>
                          </FormGroup>

                          <FormGroup className='mb-2'>
                              <Label>Code 2:</Label>
                              <Input
                                  type='text'
                                  value={editData.code2 || ''}
                                  onChange={(e) => handleInputChange('code2', e.target.value)}
                                  className='form-control-sm'
                              />
                              <small className='text-muted'>Ajouté: {formatDate(promo.code2_added)}</small>
                          </FormGroup>

                          <FormGroup className='mb-2'>
                              <Label>Code 3:</Label>
                              <Input
                                  type='text'
                                  value={editData.code3 || ''}
                                  onChange={(e) => handleInputChange('code3', e.target.value)}
                                  className='form-control-sm'
                              />
                              <small className='text-muted'>Ajouté: {formatDate(promo.code3_added)}</small>
                          </FormGroup>

                          <FormGroup className='mb-2'>
                              <Label>Cote Code 1:</Label>
                              <Input
                                  type='text'
                                  value={editData.cote_code1 || ''}
                                  onChange={(e) => handleInputChange('cote_code1', e.target.value)}
                                  className='form-control-sm'
                              />
                          </FormGroup>

                          <FormGroup className='mb-2'>
                              <Label>Cote Code 2:</Label>
                              <Input
                                  type='text'
                                  value={editData.cote_code2 || ''}
                                  onChange={(e) => handleInputChange('cote_code2', e.target.value)}
                                  className='form-control-sm'
                              />
                          </FormGroup>

                          <FormGroup className='mb-2'>
                              <Label>Cote Code 3:</Label>
                              <Input
                                  type='text'
                                  value={editData.cote_code3 || ''}
                                  onChange={(e) => handleInputChange('cote_code3', e.target.value)}
                                  className='form-control-sm'
                              />
                          </FormGroup>

                          <FormGroup className='mb-2'>
                              <Label>Lien:</Label>
                              <Input
                                  type='text'
                                  value={editData.play_now_link || ''}
                                  onChange={(e) => handleInputChange('play_now_link', e.target.value)}
                                  className='form-control-sm'
                              />
                          </FormGroup>

                          <div className='d-flex gap-2 mt-3'>
                              <Btn attrBtn={{ color: 'primary', size: 'sm', onClick: () => handleSave(promo), disabled: saving }}>
                                  {saving ? 'Enregistrement...' : 'Enregistrer'}
                              </Btn>
                              <Btn attrBtn={{ color: 'secondary', size: 'sm', onClick: handleCancel, disabled: saving }}>
                                  Annuler
                              </Btn>
                          </div>
                      </div>

                      
                      <div className='mt-2'>
                        <small className='text-muted'>
                          Créé: {formatDate(promo.created_at)}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          ))
        ) : (
          <Col xl='12'>
            <Card className='card-with-border bookmark-card'>
              <div className='details-website'>
                <div className='desciption-data p-4'>
                  <div className='title-bookmark'>
                    <H6 attrH6={{ className: 'mb-3' }}>Ajouter un Code Promo</H6>
                    
                    <FormGroup className='mb-2'>
                      <Label>Code 1:</Label>
                      <Input
                        type='text'
                        value={editData.code1 || ''}
                        onChange={(e) => handleInputChange('code1', e.target.value)}
                        className='form-control-sm'
                        placeholder='Entrez le code 1'
                      />
                    </FormGroup>

                    <FormGroup className='mb-2'>
                      <Label>Code 2:</Label>
                      <Input
                        type='text'
                        value={editData.code2 || ''}
                        onChange={(e) => handleInputChange('code2', e.target.value)}
                        className='form-control-sm'
                        placeholder='Entrez le code 2'
                      />
                    </FormGroup>

                    <FormGroup className='mb-2'>
                      <Label>Code 3:</Label>
                      <Input
                        type='text'
                        value={editData.code3 || ''}
                        onChange={(e) => handleInputChange('code3', e.target.value)}
                        className='form-control-sm'
                        placeholder='Entrez le code 3'
                      />
                    </FormGroup>

                    <FormGroup className='mb-2'>
                      <Label>Cote Code 1:</Label>
                      <Input
                        type='text'
                        value={editData.cote_code1 || ''}
                        onChange={(e) => handleInputChange('cote_code1', e.target.value)}
                        className='form-control-sm'
                        placeholder='Entrez le cote code 1'
                      />
                    </FormGroup>

                    <FormGroup className='mb-2'>
                      <Label>Cote Code 2:</Label>
                      <Input
                        type='text'
                        value={editData.cote_code2 || ''}
                        onChange={(e) => handleInputChange('cote_code2', e.target.value)}
                        className='form-control-sm'
                        placeholder='Entrez le cote code 2'
                      />
                    </FormGroup>

                    <FormGroup className='mb-2'>
                      <Label>Cote Code 3:</Label>
                      <Input
                        type='text'
                        value={editData.cote_code3 || ''}
                        onChange={(e) => handleInputChange('cote_code3', e.target.value)}
                        className='form-control-sm'
                        placeholder='Entrez le cote code 3'
                      />
                    </FormGroup>

                    <FormGroup className='mb-2'>
                      <Label>Lien:</Label>
                      <Input
                        type='text'
                        value={editData.play_now_link || ''}
                        onChange={(e) => handleInputChange('play_now_link', e.target.value)}
                        className='form-control-sm'
                        placeholder='https://example.com/play'
                      />
                    </FormGroup>

                    <div className='d-flex gap-2 mt-3'>
                      <Btn attrBtn={{ color: 'primary', size: 'sm', onClick: () => handleSave(null), disabled: saving }}>
                        {saving ? 'Ajout...' : 'Ajouter'}
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        )}
      </Row>
    </Fragment>
  );
};

export default PromoCodeDataLoop;
